<app-data-table [configuration]="dataTableConfiguration" />
